



































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import accountsApi from "@/services/accounts";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter } from "vuex-class";

import { NSLog } from "@/helpers/log";
import { save, load } from "@/helpers/storage";
const log = NSLog("view/Home");

@Component({
  components: {
    loader
  }
})
export default class DateRangeFilter extends Vue {
  @Prop() public value: any;
  public showFrom = false;
  public showTo = false;

  public fromDate: any = "";
  public toDate: any = "";

  public mode = "last-month";

  public items: any = [
    { val: "today", text: "Today" },
    // { val: "yesterday", text: "Yesterday" },
    { val: "last-week", text: "Last week" },
    { val: "last-month", text: "Last Month" },
    { val: "last-6-month", text: "Last 6 Months" },
    { val: "last-year", text: "Last Year" },
    { val: "last-2-year", text: "Last 2 Years" },
    { val: "custom", text: "Custom" }
  ];
  @Watch("mode", { deep: true }) public watchMode() {
    this.checkCustom();
  }

  @Watch("fromDate") public watchFromDate() {
    this.checkCustom();
  }
  @Watch("toDate") public watchToDate() {
    this.checkCustom();
  }

  public created() {
    if (this.value) {
      if (this.value.from && this.value.to) {
        this.mode = "custom";
        this.fromDate = this.value.from;
        this.toDate = this.value.to;
      } else { this.mode = this.value; }
    }
    this.checkCustom();
  }
  private checkCustom() {
    if (this.fromDate && this.toDate && this.mode === "custom") {
      this.$emit("input", {
        from: this.fromDate,
        to: this.toDate
      });
    } else {
      this.$emit("input", this.mode);
    }
  }
}
